/* Product purchase handler: one owner, bound before a button is enabled. */
(function () {
  'use strict';
  if (window.HolyAtcCoreReady) return;
  window.HolyAtcCoreReady = true;
  const selector = '[data-btn-addtocart]';
  function ready() {
    document.querySelectorAll(selector).forEach(button => {
      button.dataset.atcCoreInitialized = 'true';
      if (button.hasAttribute('data-hs-atc-wait')) {
        button.disabled = false;
        button.removeAttribute('data-hs-atc-wait');
        button.removeAttribute('aria-busy');
      }
    });
  }
  async function add(button, form) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
    const previousDisabled = button.disabled;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    let status = form.querySelector('[data-hs-atc-status]');
    if (!status) {
      status = document.createElement('p');status.dataset.hsAtcStatus = '';status.setAttribute('role','status');form.appendChild(status);
    }
    status.textContent = 'Adicionando ao carrinho…';
    const root = window.Shopify?.routes?.root || '/';
    const data = new FormData(form);
    try {
      if (!data.get('id')) throw new Error('Selecione o produto antes de adicionar.');
      const response = await fetch(root + 'cart/add.js', {method:'POST',body:data});
      const item = await response.json();
      if (!response.ok || item.status >= 400) throw new Error(item.description || 'Não foi possível adicionar. Tente novamente.');
      status.textContent = 'Produto adicionado ao carrinho.';
      document.dispatchEvent(new CustomEvent('atc-core:added',{detail:{variantId:data.get('id'),data:item},bubbles:true}));
      window.dispatchEvent(new CustomEvent('cart-change'));
      if (window.after_add_to_cart?.type === 'cart') window.location.href = window.routes?.cart || root + 'cart';
    } catch (error) {
      status.textContent = error.message === 'Failed to fetch' ? 'Não foi possível confirmar a inclusão. Confira o carrinho antes de tentar novamente.' : error.message;
      document.dispatchEvent(new CustomEvent('atc-core:error',{detail:{error},bubbles:true}));
    } finally {
      button.disabled = previousDisabled;button.removeAttribute('aria-busy');button.classList.remove('is-loading');
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest(selector);
    const form = button?.closest('form');
    if (!button || !form || button.tagName === 'A' || !form.querySelector('[name="id"]')) return;
    event.preventDefault();event.stopImmediatePropagation();
    add(button, form);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    const button = form.querySelector?.(selector);
    if (!button || !form.querySelector('[name="id"]')) return;
    event.preventDefault();event.stopImmediatePropagation();add(button, form);
  }, true);
  ready();
  const observer = new MutationObserver(ready);
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
